// extracted by mini-css-extract-plugin
export default {"container":"FilesPage_container__yn8PY","sidebar":"FilesPage_sidebar__q6SZC","main":"FilesPage_main__BcP56"};